import { AttributeSetup } from "@acng/frontend-stargazer";
import { remove } from '@acng/frontend-bounty/dom/move.js';

const name = 'has-image';

AttributeSetup(name, () => (element, value, compiler) => {
  if (value === '') {
    console.info('Remove', element.outerHTML, compiler);
    remove(element);
  }
});

export { name as WEBLOG_HAS_IMAGE };
